import { User } from './user';
import { Event } from './event';

export enum StaffType {
  DJ = 'DJ',
  MUSICIAN = 'MUSICIAN',
  SOUND_ENGINEER = 'SOUND_ENGINEER',
  LIGHT_TECHNICIAN = 'LIGHT_TECHNICIAN',
  VIDEO_TECHNICIAN = 'VIDEO_TECHNICIAN',
  PHOTOGRAPHER = 'PHOTOGRAPHER',
  BARTENDER = 'BARTENDER',
  SECURITY = 'SECURITY',
  OTHER = 'OTHER'
}

export enum MusicGenre {
  // Genres principaux
  POP = 'POP',
  ROCK = 'ROCK',
  HIP_HOP = 'HIP_HOP',
  RAP = 'RAP',
  RNB = 'RNB',
  ELECTRONIC = 'ELECTRONIC',
  JAZZ = 'JAZZ',
  BLUES = 'BLUES',
  REGGAE = 'REGGAE',
  FUNK = 'FUNK',
  SOUL = 'SOUL',
  CLASSICAL = 'CLASSICAL',
  AMBIENT = 'AMBIENT',
  FOLK = 'FOLK',
  COUNTRY = 'COUNTRY',
  LATIN = 'LATIN',
  METAL = 'METAL',
  PUNK = 'PUNK',
  INDIE = 'INDIE',
  
  // Sous-genres électroniques
  HOUSE = 'HOUSE',
  TECHNO = 'TECHNO',
  TRANCE = 'TRANCE',
  DRUM_AND_BASS = 'DRUM_AND_BASS',
  DUBSTEP = 'DUBSTEP',
  EDM = 'EDM',
  TRAP = 'TRAP',
  
  // Autres
  WORLD = 'WORLD',
  EXPERIMENTAL = 'EXPERIMENTAL',
  LOFI = 'LOFI',
  OTHER = 'OTHER'
}

export interface StaffProfile {
  id: number;
  userId: number;
  user?: User;
  staffType: StaffType;
  genres: MusicGenre[] | string;
  experience: string;
  equipmentDescription?: string;
  portfolio?: string;
  soundcloudUrl?: string;
  spotifyUrl?: string;
  bandcampUrl?: string;
  mixcloudUrl?: string;
  instagramUrl?: string;
  availability: string;
  hourlyRate?: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface StaffApplication {
  id: number;
  staffProfileId: number;
  staffProfile?: StaffProfile;
  staffRequestId: number;
  staffRequest?: StaffRequest;
  message: string;
  status: 'PENDING' | 'ACCEPTED' | 'REJECTED';
  createdAt: string;
  updatedAt: string;
}

export interface StaffRequest {
  id: number;
  eventId: number;
  event?: Event;
  staffType: StaffType;
  requiredGenres?: MusicGenre[];
  description: string;
  equipmentProvided: boolean;
  equipmentDescription?: string;
  budget?: number;
  isActive: boolean;
  applications?: StaffApplication[];
  createdAt: string;
  updatedAt: string;
}

export interface CreateStaffProfilePayload {
  staffType: StaffType;
  genres: MusicGenre[];
  experience: string;
  equipmentDescription?: string;
  portfolio?: string;
  soundcloudUrl?: string;
  spotifyUrl?: string;
  bandcampUrl?: string;
  mixcloudUrl?: string;
  instagramUrl?: string;
  availability: string;
  hourlyRate?: number;
  isActive: boolean;
}

export interface UpdateStaffProfilePayload extends CreateStaffProfilePayload {
  id: number;
}

export interface CreateStaffApplicationPayload {
  staffProfileId: number;
  staffRequestId: number;
  message: string;
}

export interface CreateStaffRequestPayload {
  eventId: number;
  staffType: StaffType;
  requiredGenres?: MusicGenre[];
  description: string;
  equipmentProvided: boolean;
  equipmentDescription?: string;
  budget?: number;
}

export interface UpdateStaffRequestPayload extends CreateStaffRequestPayload {
  id: number;
  isActive: boolean;
}

export const STAFF_TYPE_LABELS: Record<StaffType, string> = {
  [StaffType.DJ]: 'DJ',
  [StaffType.MUSICIAN]: 'Musicien',
  [StaffType.SOUND_ENGINEER]: 'Ingénieur son',
  [StaffType.LIGHT_TECHNICIAN]: 'Technicien lumière',
  [StaffType.VIDEO_TECHNICIAN]: 'Technicien vidéo',
  [StaffType.PHOTOGRAPHER]: 'Photographe',
  [StaffType.BARTENDER]: 'Barman',
  [StaffType.SECURITY]: 'Agent de sécurité',
  [StaffType.OTHER]: 'Autre'
};

export const MUSIC_GENRE_LABELS: Record<MusicGenre, string> = {
  [MusicGenre.POP]: 'Pop',
  [MusicGenre.ROCK]: 'Rock',
  [MusicGenre.HIP_HOP]: 'Hip-Hop',
  [MusicGenre.RAP]: 'Rap',
  [MusicGenre.RNB]: 'R&B',
  [MusicGenre.ELECTRONIC]: 'Électronique',
  [MusicGenre.JAZZ]: 'Jazz',
  [MusicGenre.BLUES]: 'Blues',
  [MusicGenre.REGGAE]: 'Reggae',
  [MusicGenre.FUNK]: 'Funk',
  [MusicGenre.SOUL]: 'Soul',
  [MusicGenre.CLASSICAL]: 'Classique',
  [MusicGenre.AMBIENT]: 'Ambient',
  [MusicGenre.FOLK]: 'Folk',
  [MusicGenre.COUNTRY]: 'Country',
  [MusicGenre.LATIN]: 'Latin',
  [MusicGenre.METAL]: 'Metal',
  [MusicGenre.PUNK]: 'Punk',
  [MusicGenre.INDIE]: 'Indie',
  [MusicGenre.HOUSE]: 'House',
  [MusicGenre.TECHNO]: 'Techno',
  [MusicGenre.TRANCE]: 'Trance',
  [MusicGenre.DRUM_AND_BASS]: 'Drum & Bass',
  [MusicGenre.DUBSTEP]: 'Dubstep',
  [MusicGenre.EDM]: 'EDM',
  [MusicGenre.TRAP]: 'Trap',
  [MusicGenre.WORLD]: 'Musique du monde',
  [MusicGenre.EXPERIMENTAL]: 'Expérimental',
  [MusicGenre.LOFI]: 'Lo-Fi',
  [MusicGenre.OTHER]: 'Autre'
};
